import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';
import { useAssistantName } from '../../queries/agents';
import { useNeedsYou } from '../../queries/actions';
import { rank, roleLabel } from '../../utils/actions';
import { BellButton, BellBadge, AlertPop, ClickAway } from './styled';

export default function SlaBell() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const agent = useAssistantName();
  const needs = [...useNeedsYou(user)].sort((a, b) => rank(a) - rank(b));
  const go = (state) => {
    setOpen(false);
    navigate('/todos', { state });
  };

  return (
    <>
      <BellButton type="button" $alert={needs.length > 0} onClick={() => setOpen((v) => !v)} aria-label={`Notifications, ${needs.length} new`}>
        <FontAwesomeIcon icon={faBell} />
        {needs.length > 0 && <BellBadge>{needs.length}</BellBadge>}
      </BellButton>

      {open && (
        <>
          <ClickAway onClick={() => setOpen(false)} />
          <AlertPop role="dialog" aria-label="Notifications">
            <div className="ap-head">
              <div className="ap-title">Notifications</div>
              <div className="ap-sub">
                {needs.length} need{needs.length === 1 ? 's' : ''} you
              </div>
            </div>
            <div className="ap-list">
              {needs.length === 0 && <div className="ap-empty">Nothing new.</div>}
              {needs.map((x) => (
                <button key={x._id} type="button" className="ap-row" onClick={() => go({ openActionId: x._id })}>
                  <span className="ap-dot">
                    <FontAwesomeIcon icon={faCircleExclamation} />
                  </span>
                  <span className="ap-body">
                    <span className="ap-name">{x.title}</span>
                    <span className="ap-meta">
                      {x.who} · Waiting on {roleLabel(x.wait, agent)}
                    </span>
                    {x.aging?.text && (
                      <span className="ap-tags">
                        <span className={`ap-due tone-${x.aging.state === 'red' ? 'danger' : 'warning'}`}>{x.aging.text}</span>
                      </span>
                    )}
                  </span>
                </button>
              ))}
            </div>
            <button type="button" className="ap-cta" onClick={() => go(null)}>
              Open Agent Actions
            </button>
          </AlertPop>
        </>
      )}
    </>
  );
}
